module.exports = __webpack_public_path__ + "img/shape-6@2x.4f4fa204.png";